import xhr from 'Common/utils/xhr'
import { foldersEndpoint } from './endpoints'

/**
 * Unpublish a folder (ESL Folders account only)
 * @param {number} id - The folder ID
 */
const unpublishFolder = id =>
  xhr({
    url: `${foldersEndpoint}/${id}`,
    method: 'PUT',
    data: {
      folder: {
        esl_published_at: null,
      },
    },
  })

export default unpublishFolder
